export default {
    /**
     * Get SessionUUID from a Submission View Model
     *
     * @param {Object} [submissionViewModel]
     * @returns {*} null if the view model does not have a sessionUUID, sessionUUID otherwise
     */
    getSessionUUID: function getSessionUUID(submissionViewModel) {
        if (submissionViewModel && submissionViewModel.sessionUUID) {
            return submissionViewModel.sessionUUID.value;
        }

        return null;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/util/SessionUtil.js
// module id = 21
// module chunks = 0